import { render, staticRenderFns } from "./CrudEdit.vue?vue&type=template&id=f0f9f49a&"
import script from "./CrudEdit.vue?vue&type=script&lang=js&"
export * from "./CrudEdit.vue?vue&type=script&lang=js&"
import style0 from "./CrudEdit.vue?vue&type=style&index=0&id=f0f9f49a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports